module.exports = __webpack_public_path__ + "img/steel-furnace-working.e37f61d7.png";